'use strict';

/**
 * Send request to adform that ad is clicked. Redirect after that to an ad link.
 *
 * @param {string} requestUrl - adform request url
 * @param {string} redirectUrl - url to redirect to
 */
function makeAdClickedRequestAndRedirect(
    requestUrl,
    redirectUrl
) {
    fetch(requestUrl, {
        method: 'GET',
        keepalive: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .catch(() => false)
        .finally(() => {
            window.location.href = redirectUrl;
        });
}

/**
 * Send request to adform that ad is in viewport.
 *
 * @param {string} impTrackerURL - adform request url
 */
function makeAdInViewportRequest(impTrackerURL) {
    fetch(impTrackerURL)
        .catch(() => {});
}

module.exports = {
    makeAdClickedRequestAndRedirect: makeAdClickedRequestAndRedirect,
    makeAdInViewportRequest: makeAdInViewportRequest
};
